import { Component, OnInit } from '@angular/core';
import { RowEvent } from 'ag-grid-community';
import { Helper } from 'src/app/shared/classes/Helper';
import { HitApi } from 'src/app/shared/classes/HitApi';
import { ModalInjectedData } from 'src/app/shared/classes/ModalInjectedData';
import { Widget } from 'src/app/shared/classes/Widget';
import { ButtonType } from 'src/app/shared/enums/ButtonType';
import { IconType } from 'src/app/shared/enums/IconType';
import { IntegrationName } from 'src/app/shared/enums/IntegrationName';
import { ModalType } from 'src/app/shared/enums/ModalType';
import { IModalData } from 'src/app/shared/interfaces/modal/IModalData';
import { ITableGeneratorInput } from 'src/app/shared/interfaces/table-generator/ITableGeneratorInput';
import { OtrsChildIntegrationComponent } from '../otrs-child-integration/otrs-child-integration.component';
import { OtrsParentIntegrationStepOneComponent } from '../otrs-parent-integration-step-one/otrs-parent-integration-step-one.component';
import { OtrsParentIntegrationStepTwoComponent } from '../otrs-parent-integration-step-two/otrs-parent-integration-step-two.component';
import { ButtonColorType } from './../../../../../enums/ButtonColorType';
import { MultiButtonGeneratorComponent } from './../../../../multi-button-generator/multi-button-generator.component';

@Component({
    selector: 'app-otrs-integrations-table',
    templateUrl: './otrs-integrations-table.component.html',
    styleUrls: ['./otrs-integrations-table.component.sass']
})
export class OtrsIntegrationsTableComponent implements OnInit {
    widgetRef: Widget;
    tableGenInput: ITableGeneratorInput = null;
    tableData = [];
    response;
    constructor(private modalInputData: ModalInjectedData) {
        this.response = modalInputData.data['response'];
        if (this.response['userCred']) {
            this.tableData.push({
                ...this.response['userCred'],
                ownerDeskName:
                    this.response['ownerConfiguredFeilds']['ownerDeskName']
            });
        }
        if (this.response['parentCred']) {
            this.tableData.push(this.response['parentCred']);
        }

        this.widgetRef = modalInputData.data['widgetRef'];
    }

    ngOnInit(): void {
        this.setUpBasics();
    }
    setUpBasics() {
        this.tableGenInput = {
            listExtraction: {
                type: 'DIRECT'
            },
            noDataMessage: 'No Integrations Available',
            widgetIconData: {
                type: IconType.FONTAWSOME,
                class: 'fas fa-user-plus'
            },
            columns: [
                {
                    columnKey: 'userCred',
                    columnName: 'Integration desk name',
                    cellRenderer: (rowData: RowEvent) => {
                        return rowData.data.ownerDeskName
                            ? rowData.data.ownerDeskName +
                                  ' (Child Integration)'
                            : rowData.data.deskName + ' (Parent Integration)';
                    }
                },

                {
                    columnKey: 'action',
                    columnName: 'Action',
                    pinned: 'right',
                    buttonGen: true,
                    componentFramework: MultiButtonGeneratorComponent,
                    valueFormatter: (rowData: RowEvent) => {
                        rowData['buttonGenInputs'] = [
                            {
                                buttonName: 'Edit',
                                buttonType: ButtonType.TEXT,
                                buttonColorType: ButtonColorType.INFO,
                                showLoader: false,
                                function: () => {
                                    const modalArgs: IModalData = {
                                        modalName: 'Edit OTRS',
                                        sourceId:
                                            this.widgetRef.widgetData
                                                .widgetUniqueIdentifier,
                                        modalType: ModalType.MIDDLE,
                                        modalIcon: {
                                            type: IconType.FONTAWSOME,
                                            class: 'fas fa-wrench'
                                        },
                                        modalSteps: rowData.data.deskName
                                            ? [
                                                  {
                                                      stepName: 'Credentials',
                                                      stepData: {
                                                          componentToLoad:
                                                              OtrsParentIntegrationStepOneComponent,
                                                          payload: {
                                                              data: {
                                                                  response:
                                                                      this
                                                                          .response,
                                                                  widgetRef:
                                                                      this
                                                                          .widgetRef
                                                              }
                                                          }
                                                      }
                                                  },
                                                  {
                                                      stepName:
                                                          'Configure Fields',
                                                      stepData: {
                                                          componentToLoad:
                                                              OtrsParentIntegrationStepTwoComponent,
                                                          payload: {
                                                              data: {
                                                                  response:
                                                                      this
                                                                          .response,
                                                                  widgetRef:
                                                                      this
                                                                          .widgetRef
                                                              }
                                                          }
                                                      }
                                                  }
                                              ]
                                            : [
                                                  {
                                                      stepName:
                                                          'Configure Fields',
                                                      stepData: {
                                                          componentToLoad:
                                                              OtrsChildIntegrationComponent,
                                                          payload: {
                                                              data: {
                                                                  response:
                                                                      this
                                                                          .response,
                                                                  widgetRef:
                                                                      this
                                                                          .widgetRef
                                                              }
                                                          }
                                                      }
                                                  }
                                              ],
                                        modalWidthVw: 60,
                                        modalHeightVh: 90
                                    };
                                    this.widgetRef.modalService.openModal(
                                        modalArgs
                                    );
                                    this.widgetRef.modalService.closeModal(
                                        null,
                                        this.modalInputData.modalId
                                    );
                                }
                            },
                            // DELETE BUTTON
                            {
                                buttonName: 'Delete',
                                buttonColorType: ButtonColorType.WARN,
                                buttonType: ButtonType.TEXT,
                                showLoader: true,
                                function: (modalId: Symbol) => {
                                    // Delete integration
                                    const args = Helper.generateHitApiConfig(
                                        this.widgetRef.widgetData.widgetInfo
                                            .delete
                                    );
                                    args.input = {
                                        integrationType: IntegrationName.OTRS
                                    };
                                    args.input['parentIntegration'] = rowData
                                        .data.deskName
                                        ? true
                                        : false;
                                    args.input['userIntegration'] = rowData.data
                                        .ownerDeskName
                                        ? true
                                        : false;
                                    args.function = (response) => {
                                        this.widgetRef.notificationsService.showSnackBar(
                                            `OTRS integration removed successfully`
                                        );
                                        this.widgetRef.modalService.closeModal(
                                            null,
                                            modalId
                                        );
                                        this.widgetRef.refreshWidget();
                                    };
                                    args.errorFunction = (error) => {
                                        Helper.showErrorMessage(
                                            this.widgetRef.notificationsService,
                                            error,
                                            'Error removing OTRS'
                                        );
                                        this.widgetRef.modalService.closeModal(
                                            null,
                                            modalId
                                        );
                                    };
                                    new HitApi(
                                        args,
                                        this.widgetRef.httpService,
                                        this.widgetRef.ngZone
                                    ).hitApi();
                                    this.widgetRef.modalService.closeModal(
                                        null,
                                        this.modalInputData.modalId
                                    );
                                },
                                executeFunctionAfterConfirmation: {
                                    modalName: 'Remove OTRS Integration',
                                    modalIcon: {
                                        type: IconType.FONTAWSOME,
                                        class: 'far fa-trash-alt'
                                    },
                                    contextIcon: {
                                        extraClass: 'color-accent',
                                        type: IconType.FONTAWSOME,
                                        class: 'fas fa-exclamation-triangle'
                                    },
                                    confirmationMessage: `Are you sure you want to remove OTRS ?`,
                                    buttonText: 'Remove',
                                    buttonColorType: ButtonColorType.WARN,
                                    loaderOnExec: true
                                }
                            }
                        ];
                        return rowData;
                    }
                }
            ],
            afterResponse: null,
            selection: 'single'
        };
    }
}
